<div class="spacerWrapper" fxLayout="column">
    <h2 mat-dialog-title class="dialogTitle">{{ title }}</h2>

    <div mat-dialog-content>
        <form [formGroup]="hallOfFameEditorForm">
            <div class="inputContainer">
                <label>Prefix</label>
                <mat-form-field appearance="outline">
                    <input matInput type="text" formControlName="Prefix" />
                </mat-form-field>
            </div>

            <div class="inputContainer">
                <label>First</label>
                <mat-form-field appearance="outline">
                    <input matInput type="text" formControlName="First" />
                </mat-form-field>
            </div>

            <div class="inputContainer">
                <label>Middle</label>
                <mat-form-field appearance="outline">
                    <input matInput type="text" formControlName="Middle" />
                </mat-form-field>
            </div>

            <div class="inputContainer">
                <label>Nickname</label>
                <mat-form-field appearance="outline">
                    <input matInput type="text" formControlName="Nickname" />
                </mat-form-field>
            </div>

            <div class="inputContainer">
                <label>Last</label>
                <mat-form-field appearance="outline">
                    <input matInput type="text" formControlName="Last" />
                </mat-form-field>
            </div>

            <div class="inputContainer">
                <label>Suffix</label>
                <mat-form-field appearance="outline">
                    <input matInput type="text" formControlName="Suffix" />
                </mat-form-field>
            </div>

            <div class="inputContainer">
                <label>Title</label>
                <mat-form-field appearance="outline">
                    <input matInput type="text" formControlName="Title" />
                </mat-form-field>
            </div>

            <div class="inputContainer">
                <label>Inducted</label>
                <mat-form-field appearance="outline">
                    <input matInput type="text" formControlName="Inducted" />
                </mat-form-field>
            </div>

            <div class="inputContainer">
                <label>Status</label>
                <mat-form-field appearance="outline">
                    <input matInput type="text" formControlName="Status" />
                </mat-form-field>
            </div>

            <div class="inputContainer">
                <label>School</label>
                <mat-form-field appearance="outline">
                    <input matInput type="text" formControlName="School" />
                </mat-form-field>
            </div>

            <div class="inputContainer">
                <label>Year</label>
                <mat-form-field appearance="outline">
                    <input matInput type="text" formControlName="Year" />
                </mat-form-field>
            </div>

            <div class="inputContainer">
                <label>Bio</label>
                <mat-form-field appearance="outline">
                    <textarea matInput type="text" style="min-height: 150px" formControlName="Bio"></textarea>
                </mat-form-field>
            </div>

            <div class="inputContainer">
                <label>PhotoUrl</label>
                <mat-form-field appearance="outline">
                    <input matInput type="text" formControlName="PhotoUrl" />
                </mat-form-field>
            </div>
        </form>
    </div>

    <div class="spacer" fxFlex></div>

    <div class="error-messages" fxLayout="column" fxLayoutAlign="start end">
        <mat-error *ngIf="First.invalid && First.touched">
            <mat-icon aria-hidden="false" aria-label="Error occurred in the form">error</mat-icon>
            Missing first name.
        </mat-error>
        <mat-error *ngIf="Last.invalid && Last.touched">
            <mat-icon aria-hidden="false" aria-label="Error occurred in the form">error</mat-icon>
            Missing last name.
        </mat-error>
        <mat-error *ngIf="Inducted.invalid && Inducted.touched">
            <mat-icon aria-hidden="false" aria-label="Error occurred in the form">error</mat-icon>
            Missing induction year.
        </mat-error>
        <mat-error *ngIf="Status.invalid && Status.touched">
            <mat-icon aria-hidden="false" aria-label="Error occurred in the form">error</mat-icon>
            Missing status.
        </mat-error>
        <mat-error *ngIf="School.invalid && School.touched">
            <mat-icon aria-hidden="false" aria-label="Error occurred in the form">error</mat-icon>
            Missing school.
        </mat-error>
    </div>

    <div mat-dialog-actions align="end">
        <button mat-raised-button type="submit" color="primary" (click)="onSubmit(hallOfFameEditorForm.value)">OK</button>
        <button mat-raised-button type="button" (click)="onNoClick()">Cancel</button>
    </div>
</div>
